import React from 'react'
import axios from "axios";
import {useNavigate} from "react-router-dom";
import {errorToast, successToast} from "../../components/layout/ToastStyles";
import {Apis} from "../../util/data";
import {PageBackLabel} from "../../components/layout/PageBackLabel";
import PageSection from "../../components/layout/PageSection";
import PageTitle from "../../components/layout/PageTitle";
import PageContainer from "../../components/layout/PageContainer";
import ConsejeriaForm from "./ConsejeriaForm";


const ConsejeriaNew = () => {
  const navigate = useNavigate()

  const onCreate = async (user) => {
    await axios.post(Apis.PROD + '/consejeria/new',user)
      .then(res => {
        successToast("Consejeria creada correctamente")
        navigate('/consejerias')
      })
      .catch(err => {
        errorToast(err.response.data.message,6000)
      });
  }

  return (
    <PageContainer>
      <PageSection>
        <PageBackLabel text='Consejerias' onClick={() => navigate('/consejerias')}/>
        <PageTitle title={'Consejeria nueva'}/>
      </PageSection>

      <PageSection>
        <ConsejeriaForm value={{}} onSubmit={(consej) => onCreate(consej)}/>
      </PageSection>
    </PageContainer>
  )
}

export default ConsejeriaNew;
